module.exports = __webpack_public_path__ + "09758e1b285108015ea0e87a4c186aa3.png";